(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mrp-cro-layer"] && !Shopify.designMode) return;
  try {
    (() => {
    const start = () => {
      const layer = document.getElementById('MrpCroLayer');
      if (!layer || layer.dataset.ready === 'true') return;
      layer.dataset.ready = 'true';

      const freeShippingEligible = layer.dataset.freeShippingEligible === 'true';
      const unlockedTemplate = layer.dataset.unlockedTemplate || '';
      const progressTemplate = document.getElementById('MrpShippingProgressTemplate');
      let refreshTimer;

      const installDrawerProgress = () => {
        if (!freeShippingEligible) return;
        const footer = document.querySelector('#CartDrawer .drawer__footer');
        if (!footer || footer.querySelector('[data-mrp-shipping-progress]') || !progressTemplate) return;
        footer.prepend(progressTemplate.content.cloneNode(true));
      };

      const updateShippingMessage = () => {
        if (!freeShippingEligible) return;
        installDrawerProgress();
        document.querySelectorAll('.mrp-shipping-progress').forEach((component) => {
          const messageElement = component.querySelector('.mrp-shipping-progress__message');
          if (messageElement && messageElement.textContent !== unlockedTemplate) {
            messageElement.textContent = unlockedTemplate;
          }
        });
      };

      const scheduleRefresh = () => {
        window.clearTimeout(refreshTimer);
        refreshTimer = window.setTimeout(updateShippingMessage, 80);
      };

      if (freeShippingEligible) {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, () => scheduleRefresh());
        }

        document.addEventListener('cart:lines-update', () => scheduleRefresh());
        document.addEventListener('cart:refresh', () => scheduleRefresh());

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          new MutationObserver(() => scheduleRefresh()).observe(cartDrawer, { childList: true, subtree: true });
        }
      }

      const sticky = document.getElementById('MrpStickyAtc');
      const stickyButton = sticky && sticky.querySelector('[data-mrp-sticky-button]');
      const stickyLabel = sticky && sticky.querySelector('[data-mrp-sticky-label]');
      const stickyPrice = sticky && sticky.querySelector('[data-mrp-sticky-price]');
      let primaryButton;
      let primaryObserver;
      let visibilityObserver;

      const setStickyVisibility = (visible) => {
        if (!sticky) return;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        document.body.classList.toggle('mrp-sticky-atc-visible', visible);
      };

      const syncSticky = () => {
        if (!sticky || !primaryButton) return;
        const label = primaryButton.querySelector('span');
        const price = document.querySelector('#MainContent [id^="price-"] .price-item--regular');
        stickyButton.disabled = primaryButton.disabled;
        if (label && stickyLabel) stickyLabel.textContent = label.textContent.trim();
        if (price && stickyPrice) stickyPrice.textContent = price.textContent.trim();
      };

      const bindPrimaryButton = () => {
        const nextButton = document.querySelector(
          '#MainContent product-form form[data-type="add-to-cart-form"] .product-form__submit[name="add"]',
        );
        if (!nextButton || nextButton === primaryButton) return;

        primaryButton = nextButton;
        if (primaryObserver) primaryObserver.disconnect();
        if (visibilityObserver) visibilityObserver.disconnect();
        primaryObserver = new MutationObserver(syncSticky);
        primaryObserver.observe(primaryButton, { attributes: true, childList: true, subtree: true });
        visibilityObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          const passedButton = primaryButton.getBoundingClientRect().top < 0;
          setStickyVisibility(!entry.isIntersecting && passedButton);
        });
        visibilityObserver.observe(primaryButton);
        syncSticky();
      };

      if (stickyButton) {
        stickyButton.addEventListener('click', () => {
          if (!primaryButton || primaryButton.disabled) return;
          primaryButton.click();
        });

        const mainContent = document.getElementById('MainContent');
        if (mainContent) {
          new MutationObserver(bindPrimaryButton).observe(mainContent, { childList: true, subtree: true });
        }
        bindPrimaryButton();
      }

      if (freeShippingEligible) updateShippingMessage();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
